import React from 'react';
import type { ChecklistListItem } from '../utils/checklistSelectOptions';

export function useChecklistsForSelect(): ChecklistListItem[] {
  const [checklists, setChecklists] = React.useState<ChecklistListItem[]>([]);

  React.useEffect(() => {
    let cancelled = false;
    fetch('/api/settings/checklists')
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        if (!cancelled) setChecklists(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setChecklists([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return checklists;
}
